<template>
  <table class="table table-hover table-bordered bg-white table-striped">
      <thead>
          <th>#</th>
          <th>Номер ДБЗ</th>
          <th>Действия</th>
          <th>Обновленные данные</th>
          <th>Ошибка</th>
      </thead>
      <tbody>
        <template v-if="!load">
          <tr v-for="(excel, index) in excel.import_debts" :class="{'table-success': excel.status == 'done', 'table-danger': excel.status == 'failed'}" :key="index">
              <td>{{index+1}}</td>
              <td>
                {{excel.debt_number}}
                <a :href="`/admin/debts?debt_number=${excel.debt_number}`" target="_blank" title="Найти">
                  <i class="fa fa-search" aria-hidden="true"></i>
                </a>
              </td>
              <td>{{ $t('import.' + excel.type) }}</td>
              <td :class="{'p-0': excel.type == 'distribute'}">
                <template v-for="(ex, key) in JSON.parse(excel.copyjson)">
                  <span v-if="compareTwoJson(excel.original ,excel.copyjson, key)">
                    <strong>{{ $t('debts.'+key) }}</strong>: <span class="text-success">{{JSON.parse(excel.copyjson)[key]}}</span><br>
                  </span>
                </template>
                <tbody v-if="excel.type == 'distribute' && (excel.old_user || excel.new_user)">
                  <tr>
                    <th>Предыдущий исполнитель</th>
                    <th>Назначенный исполнитель</th>
                  </tr>
                  <tr>
                    <td>{{excel.old_user ? `${excel.old_user.lastname} ${excel.old_user.firstname}`: '' }}</td>
                    <td>{{excel.new_user ? `${excel.new_user.lastname} ${excel.new_user.firstname}`: '' }}</td>
                  </tr>
                </tbody>
              </td>
              <td>{{excel.errors}}</td>
          </tr>
        </template>
        <tr v-if="load">
          <td colspan="11" class="text-center">
            <loader-wave/>
          </td>
        </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    excel: Object,
    load: Boolean,
  },
  methods: {
    compareTwoJson(original, copy, key) {
      const originalJson = JSON.parse(original);
      const copyJson = JSON.parse(copy);
      let compare = false;
      if (copyJson && key) {
        if (copyJson[key] && !originalJson) {
          compare = true;
        } else if (originalJson && originalJson[key] !== copyJson[key]) {
          if (Number.isInteger(copyJson[key]) || copyJson[key]) {
            compare = true;
          } else {
            compare = false;
          }
        }
      } else {
        compare = false;
      }

      return compare;
    },
  },
};
</script>
